module.exports = __webpack_public_path__ + "img/MES5Area_selection.277f3d36.png";